import { Add, Edit } from "@mui/icons-material"
import { Button, IconButton } from "@mui/material"
import { useEffect, useState } from "react";
import { Link } from "react-router-dom"
import commonStyles from "../../styles/Common.module.css";
import { useDispatch, useSelector } from "react-redux";
import { setIpoListFun } from "../../Redux/IPO/action";
import moment from "moment";
import tableStyles from "../Users/styles/Users.module.css";
import styles from "./styles/Ipos.module.css";

const IPOs = () => {
  const dispatch = useDispatch();
  const { ipo_articles } = useSelector((store) => store.ipo);

  useEffect(() => {
    dispatch(setIpoListFun());

    return () => {

    };
  }, []);

  return (
    <div className={commonStyles.MainContainer}>

      <div className={commonStyles.headerDiv}>
        <h1>IPO Articles</h1>

        <div>


          <Link to="/ipos/add">
            <Button color="secondary" variant="outlined" startIcon={<Add />} sx={{ width: "200px" }}
            >Add Article</Button>
          </Link>
        </div>
      </div>

      <table id={tableStyles.userListContainer}>
        <thead id={tableStyles.userListHead}>
          <tr>
            <th>Sr. No.</th>
            <th>Published At</th>
            <th>Company Name</th>
            <th></th>
          </tr>
        </thead>

        <tbody>
          {ipo_articles.map((ele, ind) => {
            return <tr className={tableStyles.userCard} key={ind}>
              <td>{ind + 1}</td>
              <td>{moment(ele.createdAt).format("Do MMM YY")}</td>
              <td className={styles.name}>{ele?.company_Id?.company_name}</td>
              <td>
                <Link to={`/ipos/${ele.slug}`}>
                  <IconButton className={styles.editButton}>
                    <Edit />
                  </IconButton>
                </Link>
              </td>
            </tr>
          })}
        </tbody>
      </table>

    </div>
  )
};

export default IPOs;